export default import.meta.ROLLDOWN_FILE_URL_3tkt537pGNF25_4N$ZWl6Q